import { pageHead } from "@app/framework/meta";
import { ContactUsPage } from "@modules/contact-us/pages";
import { trans } from "@mongez/localization";
import { MetaFunction, useLoaderData } from "@remix-run/react";

export default function ContactUs() {
  useLoaderData();
  return <ContactUsPage />;
}

export const meta: MetaFunction = ({ data }: any) => {
  return pageHead({
    title: data?.metaData?.title || trans("contactUsPage.title"),
    description:
      data?.metaData?.description || trans("contactUsPage.description"),
  });
};
